import { Avatar, Button, Card, CardContent } from '@mui/material';
import { useAuthContext } from '../../../context/AuthContextProvider';
import { getAvatar, getUserName } from '../../../models/User';

interface Props {
  showPostModal: () => void;
}

export const NewPostCard = ({ showPostModal }: Props) => {
  const { user } = useAuthContext();

  return (
    <Card>
      <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar aria-label="user avatar" alt={getUserName(user!)}>
          {getAvatar(user?.nome || '')}
        </Avatar>
        <Button
          sx={{
            ml: 2,
            width: '100%',
            padding: '10px 15px',
            justifyContent: 'flex-start',
            borderRadius: '50px',
            textTransform: 'none'
          }}
          color="secondary"
          variant="outlined"
          onClick={showPostModal}
        >
          Criar uma nova publicação
        </Button>
      </CardContent>
    </Card>
  );
};
